import React, { useEffect } from 'react';
import './FlashMessage.css';

type FlashMessageProps = {
  message: string | React.ReactNode;
  type: 'success' | 'error';
  onClose: () => void;
  duration?: number;
};

const FlashMessage: React.FC<FlashMessageProps> = ({ message, type, onClose, duration = 5000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`flash-message flash-message-${type}`}>
      <span className="flash-message-text">{message}</span>
      <button className="flash-message-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
};

export default FlashMessage;
